import React from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton
} from "@mui/material";

import {
  Edit,
  Tune,
  Assessment,
  Security,
  Settings,
  Category,
  Person
} from "@mui/icons-material";

import { useNavigate, useParams } from "react-router-dom";
import BackButton from "../BackButton";

const SettingsDashboard = () => {
  const navigate = useNavigate();

  // get domain from URL
  const { domain } = useParams();


  const cards = [
    {
      title: "Add Questions",
      icon: <Person sx={{ fontSize: 24}} />,
      path: `/admin/${domain}/add-new-questionaire`
    },
    {
      title: "Edit/Delete Questions",
      icon: <Security sx={{ fontSize: 24}} />,
      path: `/admin/${domain}/questionaire`
    },
    {
      title: "Edit Categories/Weightage",
      icon: <Category sx={{ fontSize: 24}} />,
      path: `/admin/${domain}/category`
    },
    {
      title: "Score/Maturity Levels",
      icon: <Assessment sx={{ fontSize: 24}} />,
      path: `/admin/${domain}/score-levels`
    },
  ];

  return (

    <Box
      sx={{
        minHeight: "100vh",
        p: 4,
        background:
          "radial-gradient(circle at center,#1b1f2f,#0e0f1a)"
      }}
    >
      <Paper
        sx={{
          p: 4,
          borderRadius: 6,
          background: "rgba(35,40,60,0.95)"
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#fff",
            textAlign: "center",
            mb: 1,
            fontWeight: 600
          }}
        >
          {domain?.toUpperCase()} Settings
        </Typography>

        <Typography
          sx={{
            color: "#bbb",
            textAlign: "center",
            mb: 5
          }}
        >
          Manage configuration for {domain.toUpperCase()}.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {cards.map((card) => (
            <Grid item key={card.title}>
              <Paper
                onClick={() => navigate(card.path)}
                sx={{
                  width: 180,      // fixed width
                  height: 150,     // fixed height
                  p: 3,
                  position: "relative",
                  borderRadius: 5,
                  cursor: "pointer",

                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",

                  background:
                    "rgba(224,230,255,0.95)",

                  transition: ".3s",

                  "&:hover": {
                    transform: "scale(1.05)"
                  }
                }}
              >
                {/* pencil */}
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(card.path);
                  }}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    background: "#fff",

                    "&:hover": {
                      background: "#f5f5f5"
                    }
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>

                {card.icon}

                <Typography
                  sx={{
                    mt: 3,
                    fontWeight: 600,
                    textAlign: "center",

                    // prevent card size changes
                    height: 48,
                    overflow: "hidden",

                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical"
                  }}
                >
                  {card.title}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default SettingsDashboard;